<template>
  <div class="isolate">
    <ProductJapan v-if="isJapanProductPage" />
    <ProductGlobal v-else />
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

const ProductGlobal = defineAsyncComponent(
  () =>
    import(
      '~/scopes/product-core/pages/ProductDetailPage/global/GlobalProductDetailPage.vue'
    ),
)
const ProductJapan = defineAsyncComponent(
  () =>
    import(
      '~/scopes/product-core/pages/ProductDetailPage/jp/JPProductDetailPage.vue'
    ),
)

const { market } = useMarketplace()

const isJapanProductPage = computed(
  () => market.countryCode === MarketCountryCode.JP,
)
</script>
